import cn from 'classnames';
import { t } from '../../utilities/translator';
import { BIG_GROUP_LINK } from '../../constants/constants';

const GroupBookingBigGroup = ({ isDesktopWizard = false, isChildren = false }) => {
  return (
    <div className={cn("gb-big-group flex flex-col", { 'gbm-dwiz-wrap': isDesktopWizard, 'mt-10': !isDesktopWizard, 'gap-5': isDesktopWizard, 'gap-10': !isDesktopWizard })}>
      <div className={cn("gb-message", { 'gbm-dwiz': isDesktopWizard })}>
        <div className="gbm-txt flex flex-col gap-5">
          <div>
            {isChildren ? t('groupBookingTutorial.bigGroupKidsOneRoomTxt') : t('groupBookingTutorial.bigGroupOneRoomTxt')}
          </div>
          <div className="flex flex-col">
            <b>{t('groupBookingTutorial.bigGroupMultiRoomsTitle')}</b>
            <span>
              {t('groupBookingTutorial.bigGroupMultiRoomsTxt')}
            </span>
          </div>
        </div>
      </div>
      <a href={BIG_GROUP_LINK} target="_blank" className="gbbg-link flex items-center gap-1">
        <i className="ri-information-line" />
        <span>{t('groupBookingTutorial.moreThan9')}</span>
      </a>
    </div>
  );
};

export default GroupBookingBigGroup;
